<div class="popup-container">
    <div class="popup-header">
        <i class="fas fa-video"></i> Add Details
        <span class="close-btn" (click)="close()">×</span>
    </div>

    <!--LAnguage selection-->

        <div class="cus-button">
            <button (click)="setLanguage('english')">English</button>
            <button (click)="setLanguage('french')">French</button>
            <button (click)="setLanguage('spanish')">Spanish</button>
            <button (click)="setLanguage('portuguese')">Portuguese</button>
        </div>


<hr class="ss">


  <!--For english-->
    <div class="english" *ngIf="languageSelected === 'english'">
        <div class="popup-body mt-2">
            <form [formGroup]="videoForm">
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>H2 Title For English</label>
                    <input type="text" id="title" maxlength="60" formControlName="title" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Url For English</label>
                    <input type="text" id="title" maxlength="60" formControlName="seo_url" name="title" placeholder="Enter SEO URL">
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Title For English</label>
                    <input type="text" id="title"  maxlength="60" formControlName="seotitle" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Description For English</label>
                    <input type="text" id="title" formControlName="seodescription" maxlength="160" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="keywords"><i class="fas fa-heading"></i> SEO Keywords For English</label>
                <input
                type="text"
                id="keywords"
                formControlName="keywords1"
                name="keywordInput"
                (keyup.enter)="addKeyword()"
                placeholder="Enter keyword and press Enter"
                class="form-control">
                <div class="chips-container">
                    <span *ngFor="let keyword of keywordsArray; let i = index" class="chip">
                        {{ keyword }}
                        <span class="close-btn" (click)="removeKeyword(i)">&times;</span>
                    </span>
                </div>
            </div>
                <div class="form-group">
                    <label for="description"><i class="fas fa-align-left"></i>Description For English</label>
                    <textarea id="description" formControlName="description" name="description" placeholder="Enter video description" required></textarea>
                </div>
                <div class="quill-editor-wrapper form-group">
                    <label for="description"><i class="fas fa-align-left"></i>More Description For English</label>
                    <quill-editor formControlName="more_description" style="min-width: 300px; width: 100%; margin-top: 5px;"></quill-editor>
                </div>
                <div class="form-group">
                    <label for="category"><i class="fas fa-list"></i> Product Name For English</label>
                    <select id="category" name="category" formControlName="category" >
                        <option value="">-- Select --</option>
                        <option value="1">Medeil</option>
                        <option value="2">Medeil Cloud POS</option>
                        <option value="3">Medeil Cloud HQ</option>
                        <option value="4">Hosbay</option>
                        <option value="5">Allotmed</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="publishDate"><i class="fas fa-calendar"></i>Publish Date For English</label>
                    <input type="date" id="publishDate" formControlName="publishdate" name="publishDate" required>
                </div>
                <!-- <div class="form-group">
                    <label for="videoUpload"><i class="fas fa-upload"></i> Upload Video</label>
                    <input type="file" id="videoUpload" name="videoUpload" accept="video/*">
                </div> -->
                <div class="form-group">
                    <label for="videoLink"><i class="fas fa-link"></i> Video Link For English</label>
                    <input type="url" id="videoLink" formControlName="videolink" name="videoLink" placeholder="Paste video URL (e.g., YouTube)">
                </div>

                <div class="cta-container mt-2 ">
                    <label>
                    <input type="checkbox" formControlName="cta_button_enabled">
                    Enable CTA Button
                    </label>
                    <button (click)="toggleAction()" class="toggle-btn" *ngIf="videoForm.get('cta_button_enabled')?.value"
                        [ngClass]="{'popup-btn': videoForm.get('togglecontrol')?.value}">
                        {{ videoForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>
                    <!-- Fields will only be shown if the checkbox is checked -->
                    <div *ngIf="videoForm.get('cta_button_enabled')?.value" class="form-group">
                    <input type="text" class="mt-2" formControlName="cta_button_text" placeholder="Enter button name" />
                    <input type="text" class="mt-2"  formControlName="cta_button_link" *ngIf="!videoForm.get('togglecontrol')?.value" placeholder="Enter button link" />
                    <input type="text" class="mt-2"  formControlName="cta_button_source_name" *ngIf="videoForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
                    </div>
                </div>

            </form>
        </div>
    </div>

    <!--if french-->
    <div class="french" *ngIf="languageSelected==='french'">
        <div class="popup-body mt-2">
            <form [formGroup]="videoForm">
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>H2 Title For French</label>
                    <input type="text" id="title" maxlength="60" formControlName="titlefr" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Url For French</label>
                    <input type="text" id="title" maxlength="60" formControlName="seo_urlfr" name="title" placeholder="Enter SEO URL">
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Title For French</label>
                    <input type="text" id="title"  maxlength="60" formControlName="seotitlefr" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Description For French</label>
                    <input type="text" id="title" formControlName="seodescriptionfr" maxlength="160" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="keywords"><i class="fas fa-heading"></i> SEO Keywords For French</label>
                <input
                type="text"
                id="keywords"
                formControlName="keywords1fr"
                name="keywordInput"
                (keyup.enter)="addKeyword()"
                placeholder="Enter keyword and press Enter"
                class="form-control">
            <div class="chips-container">
                <span *ngFor="let keyword of keywordsArray; let i = index" class="chip">
                {{ keyword }}
                <span class="close-btn" (click)="removeKeyword(i)">&times;</span>
                </span>
            </div>
            </div>
                <div class="form-group">
                    <label for="description"><i class="fas fa-align-left"></i> Description For French</label>
                    <textarea id="description" formControlName="descriptionfr" name="description" placeholder="Enter video description" required></textarea>
                </div>
                <div class="quill-editor-wrapper form-group">
                    <label for="description"><i class="fas fa-align-left"></i>More Description For French</label>
                    <quill-editor formControlName="more_descriptionfr" style="min-width: 300px; width: 100%; margin-top: 5px;"></quill-editor>
                </div>
                <div class="form-group">
                    <label for="category"><i class="fas fa-list"></i> Product Name For French</label>
                    <select id="category" name="category" formControlName="categoryfr" >
                        <option value="">-- Select --</option>
                        <option value="1">Medeil</option>
                        <option value="2">Medeil Cloud POS</option>
                        <option value="3">Medeil Cloud HQ</option>
                        <option value="4">Hosbay</option>
                        <option value="5">Allotmed</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="publishDate"><i class="fas fa-calendar"></i> Publish Date For French</label>
                    <input type="date" id="publishDate" formControlName="publishdatefr" name="publishDate" required>
                </div>
                <!-- <div class="form-group">
                    <label for="videoUpload"><i class="fas fa-upload"></i> Upload Video</label>
                    <input type="file" id="videoUpload" name="videoUpload" accept="video/*">
                </div> -->
                <div class="form-group">
                    <label for="videoLink"><i class="fas fa-link"></i> Video Link For French</label>
                    <input type="url" id="videoLink" formControlName="videolinkfr" name="videoLink" placeholder="Paste video URL (e.g., YouTube)">
                </div>
                <div class="cta-container mt-2 ">
                    <label>
                    <input type="checkbox" formControlName="cta_button_enabledfr">
                    Enable CTA Button
                    </label>
                    <button (click)="toggleAction()" class="toggle-btn" *ngIf="videoForm.get('cta_button_enabled')?.value"
                        [ngClass]="{'popup-btn': videoForm.get('togglecontrol')?.value}">
                        {{ videoForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>
                    <!-- Fields will only be shown if the checkbox is checked -->
                    <div *ngIf="videoForm.get('cta_button_enabled')?.value" class="form-group">
                    <input type="text" class="mt-2" formControlName="cta_button_textfr" placeholder="Enter button name" />
                    <input type="text" class="mt-2"  formControlName="cta_button_linkfr" *ngIf="!videoForm.get('togglecontrol')?.value" placeholder="Enter button link" />
                    <input type="text" class="mt-2"  formControlName="cta_button_source_namefr" *ngIf="videoForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
                    </div>
                </div>
            </form>
        </div>
    </div>


    <!--If Spanish-->
    <div class="spanish" *ngIf="languageSelected==='spanish'">

        <div class="popup-body mt-2">
            <form [formGroup]="videoForm">
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>H2 Title For Spanish</label>
                    <input type="text" id="title" maxlength="60" formControlName="titlesp" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Url For Spanish</label>
                    <input type="text" id="title" maxlength="60" formControlName="seo_urlsp" name="title" placeholder="Enter SEO URL">
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Title For Spanish</label>
                    <input type="text" id="title"  maxlength="60" formControlName="seotitlesp" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Description For Spanish</label>
                    <input type="text" id="title" formControlName="seodescriptionsp" maxlength="160" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="keywords"><i class="fas fa-heading"></i> SEO Keywords For Spanish</label>
                <input
                type="text"
                id="keywords"
                formControlName="keywords1sp"
                name="keywordInput"
                (keyup.enter)="addKeyword()"
                placeholder="Enter keyword and press Enter"
                class="form-control">
            <div class="chips-container">
                <span *ngFor="let keyword of keywordsArray; let i = index" class="chip">
                {{ keyword }}
                <span class="close-btn" (click)="removeKeyword(i)">&times;</span>
                </span>
            </div>
            </div>
                <div class="form-group">
                    <label for="description"><i class="fas fa-align-left"></i> Description For Spanish</label>
                    <textarea id="description" formControlName="descriptionsp" name="description" placeholder="Enter video description" required></textarea>
                </div>
                <div class="quill-editor-wrapper form-group">
                    <label for="description"><i class="fas fa-align-left"></i>More Description For Spanish</label>
                    <quill-editor formControlName="more_descriptionsp" style="min-width: 300px; width: 100%; margin-top: 5px;"></quill-editor>
                </div>
                <div class="form-group">
                    <label for="category"><i class="fas fa-list"></i> Product Name For Spanish</label>
                    <select id="category" name="category" formControlName="categorysp" >
                        <option value="">-- Select --</option>
                        <option value="1">Medeil</option>
                        <option value="2">Medeil Cloud POS</option>
                        <option value="3">Medeil Cloud HQ</option>
                        <option value="4">Hosbay</option>
                        <option value="5">Allotmed</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="publishDate"><i class="fas fa-calendar"></i> Publish Date For Spanish</label>
                    <input type="date" id="publishDate" formControlName="publishdatesp" name="publishDate" required>
                </div>
                <!-- <div class="form-group">
                    <label for="videoUpload"><i class="fas fa-upload"></i> Upload Video</label>
                    <input type="file" id="videoUpload" name="videoUpload" accept="video/*">
                </div> -->
                <div class="form-group">
                    <label for="videoLink"><i class="fas fa-link"></i> Video Link For Spanish</label>
                    <input type="url" id="videoLink" formControlName="videolinksp" name="videoLink" placeholder="Paste video URL (e.g., YouTube)">
                </div>
                <div class="cta-container mt-2 ">
                    <label>
                    <input type="checkbox" formControlName="cta_button_enabledsp">
                    Enable CTA Button
                    </label>
                    <button (click)="toggleAction()" class="toggle-btn" *ngIf="videoForm.get('cta_button_enabled')?.value"
                        [ngClass]="{'popup-btn': videoForm.get('togglecontrol')?.value}">
                        {{ videoForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>
                    <!-- Fields will only be shown if the checkbox is checked -->
                    <div *ngIf="videoForm.get('cta_button_enabled')?.value" class="form-group">
                    <input type="text" class="mt-2" formControlName="cta_button_textsp" placeholder="Enter button name" />
                    <input type="text" class="mt-2"  formControlName="cta_button_linksp" *ngIf="!videoForm.get('togglecontrol')?.value" placeholder="Enter button link" />
                    <input type="text" class="mt-2"  formControlName="cta_button_source_namesp" *ngIf="videoForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
                    </div>
                </div>

            </form>
        </div>
    </div>


    <!--Portuguese-->
    <div class="portuguese" *ngIf="languageSelected==='portuguese'">
        <div class="popup-body mt-2">
            <form [formGroup]="videoForm">
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>H2 Title For Portuguese</label>
                    <input type="text" id="title" maxlength="60" formControlName="titlepr" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Url For Portuguese</label>
                    <input type="text" id="title" maxlength="60" formControlName="seo_urlpr" name="title" placeholder="Enter SEO URL">
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Title For Portuguese</label>
                    <input type="text" id="title"  maxlength="60" formControlName="seotitlepr" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="title"><i class="fas fa-heading"></i>SEO Description For Portuguese</label>
                    <input type="text" id="title" formControlName="seodescriptionpr" maxlength="160" name="title" placeholder="Enter video title" required>
                </div>
                <div class="form-group">
                    <label for="keywords"><i class="fas fa-heading"></i> SEO Keywords For Portuguese</label>
                <input
                type="text"
                id="keywords"
                formControlName="keywords1pr"
                name="keywordInput"
                (keyup.enter)="addKeyword()"
                placeholder="Enter keyword and press Enter"
                class="form-control">
            <div class="chips-container">
                <span *ngFor="let keyword of keywordsArray; let i = index" class="chip">
                {{ keyword }}
                <span class="close-btn" (click)="removeKeyword(i)">&times;</span>
                </span>
            </div>
            </div>
                <div class="form-group">
                    <label for="description"><i class="fas fa-align-left"></i> Description For Portuguese</label>
                    <textarea id="description" formControlName="descriptionpr" name="description" placeholder="Enter video description" required></textarea>
                </div>
                <div class="quill-editor-wrapper form-group">
                    <label for="description"><i class="fas fa-align-left"></i>More Description For Portuguese</label>
                    <quill-editor formControlName="more_descriptionpr" style="min-width: 300px; width: 100%; margin-top: 5px;"></quill-editor>
                </div>
                <div class="form-group">
                    <label for="category"><i class="fas fa-list"></i> Product Name For Portuguese</label>
                    <select id="category" name="category" formControlName="categorypr" >
                        <option value="">-- Select --</option>
                        <option value="1">Medeil</option>
                        <option value="2">Medeil Cloud POS</option>
                        <option value="3">Medeil Cloud HQ</option>
                        <option value="4">Hosbay</option>
                        <option value="5">Allotmed</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="publishDate"><i class="fas fa-calendar"></i> Publish Date For Portuguese</label>
                    <input type="date" id="publishDate" formControlName="publishdatepr" name="publishDate" required>
                </div>
                <!-- <div class="form-group">
                    <label for="videoUpload"><i class="fas fa-upload"></i> Upload Video</label>
                    <input type="file" id="videoUpload" name="videoUpload" accept="video/*">
                </div> -->
                <div class="form-group">
                    <label for="videoLink"><i class="fas fa-link"></i> Video Link For Portuguese</label>
                    <input type="url" id="videoLink" formControlName="videolinkpr" name="videoLink" placeholder="Paste video URL (e.g., YouTube)">
                </div>
                <div class="cta-container mt-2 ">
                    <label>
                    <input type="checkbox" formControlName="cta_button_enabledpr">
                    Enable CTA Button
                    </label>
                    <button (click)="toggleAction()" class="toggle-btn" *ngIf="videoForm.get('cta_button_enabled')?.value"
                        [ngClass]="{'popup-btn': videoForm.get('togglecontrol')?.value}">
                        {{ videoForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>

                    <!-- Fields will only be shown if the checkbox is checked -->
                    <div *ngIf="videoForm.get('cta_button_enabled')?.value" class="form-group">
                    <input type="text" class="mt-2" formControlName="cta_button_textpr" placeholder="Enter button name" />
                    <input type="text" class="mt-2"  formControlName="cta_button_linkpr" *ngIf="!videoForm.get('togglecontrol')?.value" placeholder="Enter button link" />
                    <input type="text" class="mt-2"  formControlName="cta_button_source_namepr" *ngIf="videoForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
                    </div>
                </div>
            </form>
        </div>
    </div>


    <div class="popup-footer">
        <button class="cancel-btn"(click)="close()">Cancel</button>
        <button class="save-btn" (click)="saveVideo()">Save</button>
    </div>
</div>
